<template>
  <v-card>
    <v-card-title>
      <v-icon>mdi-gift-outline</v-icon>
      <span class="title ml-3">Incentivos</span>
    </v-card-title>
    <v-card-subtitle>
      <v-row class="pa-1">
        <v-col cols="4"/>
        <v-col cols="4" class="pa-0">
          <v-form @submit.prevent="cuentaGet">
            <v-text-field
                clearable
                type="number"
                v-model="cuenta"
                :rules="[
                (v) => !!v || 'Cuenta es requerida',
                (v) => /^[0-9]{7}$/i.test(v) || 'Cuenta debe ser de 7 dígitos'
                ]"
                label="Cuenta"
                placeholder="Cuenta"
                outlined
            ></v-text-field>
          </v-form>
        </v-col>
        <v-col cols="4"/>
      </v-row>
      <v-row align="center">
        <v-col cols="1">
          <div class="text-right font-weight-bold"> Nombre:</div>
        </v-col>
        <v-col cols="5">
          <v-text-field dense outlined disabled readonly hide-details v-model="incentivo.nombre"/>
        </v-col>
        <v-col cols="1">
          <div class="text-right font-weight-bold"> Direccion:</div>
        </v-col>
        <v-col cols="5">
          <v-text-field dense outlined disabled readonly hide-details v-model="incentivo.direccion"/>
        </v-col>
        <v-col cols="1">
          <div class="text-right font-weight-bold"> Mes Tarifario:</div>
        </v-col>
        <v-col cols="2">
          <v-text-field dense outlined disabled readonly hide-details v-model="incentivo.mesTarifa"/>
        </v-col>
        <v-col cols="1">
          <div class="text-right font-weight-bold"> Meses Pendientes:</div>
        </v-col>
        <v-col cols="2">
          <v-text-field dense outlined disabled readonly hide-details v-model="incentivo.pendientes"/>
        </v-col>
        <v-col cols="6">
          <div v-if="incentivo.estado!=undefined"  :style="`border-radius:7px;border: 3px solid ${incentivo.estado=='pend'?'red':incentivo.estado=='pagado'?'green':'#283593'};background: #${incentivo.estado=='pend'?'FFCDD2':incentivo.estado=='pagado'?'C8E6C9':'BBDEFB'}`" class="pa-2 text-center">
            <span :class="`${incentivo.estado=='pend'?'red':incentivo.estado=='pagado'?'green':'blue'}--text font-weight-bold`"> {{incentivo.estado=='pend'?'FALTA PAGOS':incentivo.estado=='pagado'?'REGISTRAR':'ENTREGADO'}}</span>
          </div>
        </v-col>
        <v-col cols="3" class="text-center">
          <v-btn :loading="loading" @click="incentiveSave" color="green" :disabled="incentivo.estado=='pend'?true:incentivo.estado=='pagado'?false:true"  style="color:white">
            <v-icon left>mdi-check-outline</v-icon>
            Entregar
          </v-btn>
        </v-col>
        <v-col cols="3" class="text-center">
          <v-btn :loading="loading" @click="reportUser" color="primary">
            <v-icon left>mdi-eye-outline</v-icon>
            Imprimir usuario
          </v-btn>
        </v-col>
        <v-col cols="12">
          <!--        <pre>{{incentivo.estado}}</pre>-->
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card v-if="canReporteIncentivos" class="ma-5" outlined>
      <v-card-title>
        <v-icon left>mdi-file-chart</v-icon>
        Reporte de Incentivos
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="3">
            <v-text-field
                type="date"
                v-model="filtro.fechaDesde"
                label="Fecha Desde"
                outlined dense
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
                type="date"
                v-model="filtro.fechaHasta"
                label="Fecha Hasta"
                outlined dense
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
                v-model="filtro.ventanilla"
                label="Ventanilla"
                outlined dense
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-select
                :items="entidades"
                v-model="filtro.entidad"
                label="Entidad"
                outlined dense
                clearable
            />
          </v-col>

          <v-col cols="12" class="text-center">
            <v-btn color="primary" @click="buscar" :loading="loading">
              <v-icon left>mdi-magnify</v-icon>
              Buscar
            </v-btn>

            <v-btn color="green" class="ml-2" @click="imprimirReporte">
              <v-icon left>mdi-printer</v-icon>
              Imprimir
            </v-btn>
<!--            exportar excel btn-->
            <v-btn color="success" class="ml-2" @click="exportExcel">
              <v-icon left>mdi-file-excel</v-icon>
              Exportar Excel
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
            :headers="headers"
            :items="datos"
            dense
            class="mt-4"
        >
<!--          usuarios-->
          <template v-slot:item.usuario="{ item }">
            {{ item.apellido_paterno }} {{ item.apellido_materno }} {{ item.nombre }}
          </template>
        </v-data-table>*
      </v-card-text>

      <div id="printArea" class="hidden"></div>
    </v-card>
    <v-dialog v-model="reportDialog" width="500">
      <v-card>
        <v-card-title class="headline">Reporte de Entrega</v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field v-model="fechaDesde" label="Fecha Desde" outlined type="date"/>
            <v-text-field v-model="fechaHasta" label="Fecha Hasta" outlined type="date"/>
            <v-btn @click="reportUserDate" color="primary" :loading="loading">
              <v-icon left>mdi-printer</v-icon>
              Imprimir
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div id="myPrint" class="hidden"></div>
  </v-card>
</template>

<script>
import {Alert} from "@/patrones/Alert";
import moment from "moment";
import {Printd} from 'printd'
import {http} from "@/config/HttpClient";
// import {mapGetters, mapState} from "vuex";
import {globalStore} from "@/store/globalStore";

export default {
  name: `IncentivosIndex`,
  data() {
    return {
      reportDialog: false,
      cuenta: '',
      entidades: [],
      filtro: {
        fechaDesde: moment().startOf("month").format("YYYY-MM-DD"),
        fechaHasta: moment().endOf("month").format("YYYY-MM-DD"),
        ventanilla: "",
        entidad: ""
      },
      datos: [],
      headers: [
        { text: "Fecha", value: "fecha" },
        { text: "Cuenta", value: "cuenta" },
        { text: "Nombre", value: "nombre_cliente" },
        { text: "Ventanilla", value: "ventanilla" },
        { text: "Entidad", value: "entidad" },
        { text: "Sucursal", value: "sucursal" },
        { text: "Usuario", value: "usuario" },
      //   "data": [
      // {
      //   "fecha": "2025-12-09 08:06:48",
      //   "cuenta": "2014009",
      //   "nombre": "KATHERINE",
      //   "ventanilla": "395",
      //   "entidad": "SELA",
      //   "sucursal": "1",
      //   "apellido_paterno": "YUGAR",
      //   "apellido_materno": "QUINTEROS"
      // },
      // {
      //   "fecha": "2025-12-09 08:25:22",
      //   "cuenta": "2156105",
      //   "nombre": "KATHERINE",
      //   "ventanilla": "395",
      //   "entidad": "SELA",
      //   "sucursal": "1",
      //   "apellido_paterno": "YUGAR",
      //   "apellido_materno": "QUINTEROS"
      // },

      ],
      loading: false,
      fechaDesde: '2023-12-01',
      fechaHasta: moment().format('YYYY-MM-DD'),
      hoy: moment().format('YYYY-MM-DD'),
      store: globalStore(),
      incentivo: {
        // mesesDeuda: "1",
        // nombre: "CHAMBI AJATA ADIMER PAUL",
        // direccion: "URBANIZACION 9 DE JUNIO MANZANO 111 LOTE 8",
        // cuenta: "7040855",
        // rucnit: "7336199",
        // estado: "pagado",
        // pendientes: 1,
        // mesTarifa: "202210"
      },
      incentivos: [],
    }
  },
  mounted() {
    console.log(this.store.user)
    this.entidadesGet();
    // setTimeout(()=>{
    //   this.cuentaGet()
    // },1000)
  },
  methods: {
    entidadesGet() {
      http.post("/entidades").subscribe({
        next: (res) => {
          if (res.data.success) {
            // console.log(res.data.entidades)
            this.entidades = res.data.entidades;
          }
        },
        error: (error) => {
          console.log(error);
        },
      });
    },
    buscar() {
      this.loading = true;
      http.post("/reporte-incentivos", this.filtro).subscribe({
        next: (res) => {
          this.loading = false;
          if (res.data.success) {
            this.datos = res.data.data;
          }
        },
        error: () => (this.loading = false)
      });
    },

    imprimirReporte() {
      if (this.datos.length === 0) return;

      let rows = this.datos.map((d, i) => `
        <tr>
          <td>${i + 1}</td>
          <td>${d.fecha}</td>
          <td>${d.cuenta}</td>
          <td>${d.nombre_cliente}</td>
          <td>${d.ventanilla}</td>
          <td>${d.entidad}</td>
          <td>${d.nombre}</td>
        </tr>
      `).join("");

      let html = `
        <h3 style="text-align:center">REPORTE DE INCENTIVOS</h3>
        <p>Desde: ${this.filtro.fechaDesde} - Hasta: ${this.filtro.fechaHasta}</p>
        <table border="1" width="100%" cellspacing="0" cellpadding="5">
          <tr>
            <th>#</th>
            <th>Fecha</th>
            <th>Cuenta</th>
            <th>Nombre</th>
            <th>Ventanilla</th>
            <th>Entidad</th>
            <th>Usuario</th>
          </tr>
          ${rows}
        </table>
      `;

      document.getElementById("printArea").innerHTML = html;
      new Printd().print(document.getElementById("printArea"));
    },
    exportExcel() {
      if (this.datos.length === 0) return;

      let rows = this.datos.map((d, i) => `
        <tr>
          <td>${i + 1}</td>
          <td>${d.fecha}</td>
          <td>${d.cuenta}</td>
          <td>${d.nombre_cliente}</td>
          <td>${d.ventanilla}</td>
          <td>${d.entidad}</td>
          <td>${d.nombre}</td>
        </tr>
      `).join("");

      let html = `
        <h3 style="text-align:center">REPORTE DE INCENTIVOS</h3>
        <p>Desde: ${this.filtro.fechaDesde} - Hasta: ${this.filtro.fechaHasta}</p>
        <table border="1" width="100%" cellspacing="0" cellpadding="5">
          <tr>
            <th>#</th>
            <th>Fecha</th>
            <th>Cuenta</th>
            <th>Nombre</th>
            <th>Ventanilla</th>
            <th>Entidad</th>
            <th>Usuario</th>
          </tr>
          ${rows}
        </table>
      `;

      const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `reporte_incentivos_${this.filtro.fechaDesde}_a_${this.filtro.fechaHasta}.xls`;
      link.click();
    },
    reportResumen() {
      this.$http.post(process.env.VUE_APP_URL_YAKUSELA + `reportResumen`).then(res => {
        console.log(res.data)
        if (res.data.success) {
          this.loading = false
          this.reportDialog = false
          let incentivos = []
          res.data.incentivos.forEach(incentivo => {
            if (incentivo.entidad == this.usuario.entidad) {
              incentivos.push(incentivo)
            }
          })
          this.imprimir(incentivos, 'resumen')
        } else {
          this.loading = false
          Alert.error(res.data.message)
        }
      }).catch(err => {
        this.loading = false
        Alert.error(err)
      })
    },
    reportUserDate() {
      this.loading = true
      this.$http.post(process.env.VUE_APP_URL_YAKUSELA + `reportUserDate`, {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta
      }).then(res => {
        // console.log(res.data)
        if (res.data.success) {
          this.loading = false
          this.reportDialog = false
          let incentivos = []
          res.data.incentivos.forEach(incentivo => {
            if (incentivo.entidad == this.usuario.entidad) {
              incentivos.push(incentivo)
            }
          })
          this.imprimir(incentivos, 'total')
        } else {
          this.loading = false
          Alert.error(res.data.message)
        }
      }).catch(err => {
        this.loading = false
        Alert.error(err)
      })
    },
    formatDate(fecha) {
      return moment(fecha).format('DD/MM/YYYY')
    },
    imprimir(incentivos, type = 'user') {
      if (incentivos.length === 0) {
        Alert.error('No hay datos para imprimir')
        return
      }
      let detalle = ''
      let con = 0
      let con2 = 0
      let totalUser = incentivos[0].usuario
      let titulo = ''
      if (type == 'user') {
        titulo = `REPORTE ENTREGADO DE ${this.store.user.email}`
      } else if (type == 'total') {
        titulo = `REPORTE ENTREGADO DE INCENTIVO DEL ${this.formatDate(this.fechaDesde)} AL ${this.formatDate(this.fechaHasta)}`
      } else if (type == 'resumen') {
        titulo = `REPORTE ENTREGADO DE INCENTIVO`
      }

      let reporte = ''
      if (type == 'user' || type == 'total') {
        incentivos.forEach((item) => {
          con++
          con2++
          if (totalUser != item.usuario) {
            detalle += `<tr>
            <td colspan="4" class="h6 border-bottom border"><b>Usuario:</b> ${totalUser} Cantidad: ${con - 1}  </td>
          </tr>`
            totalUser = item.usuario
            con = 1
          }
          detalle += `<tr>
          <td class="h6 border-bottom">${con}</td>
          <td class="h6 border-bottom">${item.inc_matr}</td>
          <td class="h6 border-bottom">${item.usr_apno}</td>
          <td class="h6 border-bottom">${item.inc_fech}</td>
        </tr>`
          if (incentivos.length == con2 && type == 'total') {
            detalle += `<tr>
            <td colspan="4" class="h6 border-bottom border"><b>Usuario:</b> ${item.usuario} <b>Cantidad:</b> ${con}  </td>
          </tr>`
          }
        })
        reporte = `<tr>
          <th class="h6 w-5 border bold" valign="top">No.</th>
          <th class="h6 w-10 border bold" valign="top">Cuenta</th>
          <th class="h6 w-20 border bold" valign="top">Nombre</th>
          <th class="h6 w-10 border bold" valign="top">Fecha</th>
          </tr>
          ${detalle}`
      } else {
        let sumCantidad = 0
        incentivos.forEach((item) => {

          sumCantidad += parseInt(item.total)
          con++
          detalle += `<tr>
          <td class="h6 border-bottom">${con}</td>
          <td class="h6 border-bottom">${item.inc_user}</td>
          <td class="h6 border-bottom">${item.usuario}</td>
          <td class="h6 border-bottom">${item.entidad}</td>
          <td class="h6 border-bottom right">${item.total}</td>
        </tr>`
          if (incentivos.length == con && type == 'resumen') {
            detalle += `<tr>
            <td colspan="4" class="h6 border-bottom border right"><b>TOTAL:</b>  </td> <td class="h6 border-bottom border right"> ${sumCantidad}</td>
          </tr>`
          }
        })

        reporte = `<tr>
          <th class="h6 w-5 border bold" valign="top">No.</th>
          <th class="h6 w-10 border bold" valign="top">Codigo</th>
          <th class="h6 w-20 border bold" valign="top">Nombre</th>
          <th class="h6 w-20 border bold" valign="top">Entidad</th>
          <th class="h6 w-10 border bold right" valign="top">Cantidad</th>
          </tr>
          ${detalle}`
      }
      let html = `
<style>
.w-100{
width: 100%;
}
.w-10{
width: 10%;
}
.w-5{
width: 5%;
}

.w-2{
width: 2%;
}

.w-70{
width: 70%;
}
.w-20{
width: 20%;
}
.w-30{
width: 30%;
}
.w-40{
width: 40%;
}
.w-50{
width: 50%;
}
.w-60{
width: 60%;
}
.h6{
  font-size: 0.7rem;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.0075em;
}
.caption{
  font-size: 0.50rem;
  font-weight: 400;
  line-height: 1.66;
  letter-spacing: 0.03333em;
}
.h5{
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.334;
  letter-spacing: 0em;
}
.h4{
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.235;
  letter-spacing: 0.00735em;
}
.left{
  text-align: left;
}
.center{
  text-align: center;
}

.right{
  text-align: right;
}
.border{
  border: 1px solid #000;
}
.border-top{
  border-top: 1px solid #000;
}
.border-bottom{
  border-bottom: 1px solid #000;
}
.border-left{
  border-left: 1px solid #000;
}
.border-right{
  border-right: 1px solid #000;
}
.collapse{
  border-collapse: collapse;
}
.bold{
  font-weight: bold;
}
</style>
<table class="w-100" >
<tr>
<th class="h6 w-30 bold" valign="top">Servicio de Acueducto y Alcantarillado <br> Sela</th>
<th class="h4 w-40 bold">
  <br>
  ${titulo}
</th>
<th class="h6 w-30 right bold" valign="top"> ${''} - ${this.formatDate(this.hoy)}</th>
</tr>
</table>
<table class="w-100 collapse border-left border-right" >
${reporte}
</table>
      `
      document.getElementById('myPrint').innerHTML = html
      const d = new Printd()
      d.print(document.getElementById('myPrint'))
    },
    reportUser() {
      // this.incentivos = []
      // this.loading = true
      // this.axios.post(process.env.VUE_APP_URL_YAKUSELA+'reportUser').then(res => {
      //   this.loading = false
      //   if (res.data.success) {
      //     this.imprimir(res.data.incentivos)
      //   } else {
      //     Alert.error(res.data.message)
      //   }
      // })
      this.incentivos = []
      this.loading = true
      http.post("/reportUser", {}).subscribe({
        next: (res) => {
          this.loading = false
          if (res.data.success == true) {
            this.imprimir(res.data.incentivos)
          } else {
            Alert.error(res.data.message)
          }
        },
        error: (error) => {
          this.loading = false
          console.log(error);
        },
      });
    },
    cuentaGet() {
      this.incentivo = {};
      this.loading = true
      http.post("/obtenerIncentivos", {
        cuenta: this.cuenta,
      }).subscribe({
        next: (res) => {
          this.loading = false
          if (res.data.success == true) {
            this.incentivo = res.data.cliente;
          } else {
            Alert.error(res.data.message)
          }
        },
        error: (error) => {
          this.loading = false
          console.log(error);
        },
      });
    },
    incentiveSave() {
      Alert.confirm('¿Está seguro de entregar el incentivo?').then(res => {
        if (res.value) {
          this.loading = true
          // this.axios.post(process.env.VUE_APP_URL_YAKUSELA+'insertarIncentivo',{
          //   cuenta: this.cuenta,
          // }).then(res => {
          //   this.loading = false
          //   if (res.data.success==true) {
          //     this.incentivo = {};
          //     this.cuenta = '';
          //     Alert.success('Incentivo entregado correctamente');
          //   }else{
          //     Alert.error(res.data.message)
          //   }
          // }).catch(e => {
          //   this.loading = false
          //   console.log(e);
          // });
          http.post("/insertarIncentivo", {
            cuenta: this.cuenta,
          }).subscribe({
            next: (res) => {
              this.loading = false
              if (res.data.success == true) {
                this.incentivo = {};
                this.cuenta = '';
                Alert.success('Incentivo entregado correctamente');
              } else {
                Alert.error(res.data.message)
              }
            },
            error: (error) => {
              this.loading = false
              console.log(error);
            },
          });
        }
      })
    }
  },
  computed: {
    // ...mapState([ "usuario"]),
    canReporteIncentivos(){
      console.log(this.store.permisos)
      let show = false
      // return this.store.user.permisos.includes('reporteIncentivos');
      this.store.permisos.forEach(permiso => {
        if (permiso.name === 'reporteIncentivos') {
          show = true
        }
      })
      if (!show) {
        return false
      }
      return true
    }
  },
}
</script>

<style scoped>
.hidden {
  display: none !important;
}
</style>
